import { ChevronLeft, ChevronRight } from "lucide-react";

const navBtn =
  "inline-flex items-center gap-1 rounded-full border border-white/10 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors duration-200 hover:border-cyan-400/50 hover:text-white disabled:cursor-not-allowed disabled:opacity-40";

export const StepperNav = ({ current, total, onChange }) => (
  <div className="mt-3 flex items-center gap-3" data-testid="stepper-nav">
    <button type="button" className={navBtn} onClick={() => onChange(current - 1)} disabled={current <= 1} data-testid="stepper-prev-button">
      <ChevronLeft className="h-4 w-4" aria-hidden="true" /> Prev
    </button>
    <div className="min-w-0 flex-1">
      <div className="mb-1 text-center text-[11px] font-medium text-slate-400" data-testid="stepper-progress-label">
        Founder Step {current} of {total}
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-white/[0.06]" role="progressbar" aria-valuemin={1} aria-valuemax={total} aria-valuenow={current}>
        <div
          className="h-full rounded-full bg-gradient-to-r from-[#06B6D4] via-[#2563EB] to-[#7C3AED] transition-[width] duration-500 ease-out"
          style={{ width: `${(current / total) * 100}%` }}
          data-testid="stepper-progress-bar"
        />
      </div>
    </div>
    <button type="button" className={navBtn} onClick={() => onChange(current + 1)} disabled={current >= total} data-testid="stepper-next-button">
      Next <ChevronRight className="h-4 w-4" aria-hidden="true" />
    </button>
  </div>
);
